import {SxProps, Theme} from '@mui/material';
import theme from 'src/theme';

export const formBodySx: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    px: theme.spacing(3),
    pt: 0,
    pb: theme.spacing(1),
};

export const priceInputSx: SxProps<Theme> = {
    // Remove the native number spinner arrows so the value is typed manually.
    '& input[type=number]': {
        MozAppearance: 'textfield',
    },
    '& input[type=number]::-webkit-outer-spin-button': {
        WebkitAppearance: 'none',
        margin: 0,
    },
    '& input[type=number]::-webkit-inner-spin-button': {
        WebkitAppearance: 'none',
        margin: 0,
    },
};

export const footerSx: SxProps<Theme> = {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(2),
    px: theme.spacing(3),
    pt: theme.spacing(2),
    pb: theme.spacing(3),
    borderTop: `1px solid ${theme.palette.divider}`,
};
